import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import ru from "./locales/ru.json";
import et from "./locales/et.json";
import lt from "./locales/lt.json";
import lv from "./locales/lv.json";
import pl from "./locales/pl.json";
import {
  getUserId,
  getUserLanguage,
  getTempLanguage,
} from "../api/sessionManagement";

export const resources = {
  en: {
    translation: en,
  },
  ru: {
    translation: ru,
  },
  et: {
    translation: et,
  },
  lt: {
    translation: lt,
  },
  lv: {
    translation: lv,
  },
  pl: {
    translation: pl,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en-GB",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    // Улучшенная конфигурация для предотвращения частичных переводов
    load: "languageOnly",
    preload: ["en-GB", "lv-LV", "ru-RU", "lt-LT", "pl-PL", "et-EE"],
    detection: {
      lookupLocalStorage: "i18nextLng",
      lookupSessionStorage: "i18nextLng",
      caches: ["localStorage", "sessionStorage"],
      order: ["localStorage", "sessionStorage", "navigator"],
      lookup: () => {
        const userId = getUserId();
        if (userId) {
          const userLanguage = getUserLanguage(userId);
          if (userLanguage) {
            return userLanguage;
          }
        }

        const tempLang = getTempLanguage();
        if (tempLang) {
          return tempLang;
        }

        return (
          localStorage.getItem("i18nextLng") ||
          sessionStorage.getItem("i18nextLng") ||
          navigator.language
        );
      },
    },
    react: {
      useSuspense: false,
    },
  });

export const getCurrentLanguage = () => i18n.language;
